export function getPADomain(url: string) {
  let origin = url;
  const prefixes = ["https://", "www.", "https://www.", "http://www.", "http://"];
  prefixes.forEach((prefix) => {
    if (origin.startsWith(prefix)) {
      origin = origin.replace(prefix, "");
    }
  });
  const isPADomain = ["partsavatar.ca", "dev.partsavatar.ca", "integ.partsavatar.ca", "staging.partsavatar.ca", "localhost:3000"].some((el) => origin.startsWith(el));
  return { isPADomain, routePath: isPADomain ? `/${origin.split("/")[1]}` : url };
}
